import { FormModelParser as SERVICE_WORKER_FormModelParser } from '../../../../ServiceWorker/src/helpers/form-model-parser';

export { SERVICE_WORKER_FormModelParser as FormModelParser };
